/* eslint-disable max-len */

export const SuccessDialogCheckIcon = () => {
  return (
    <svg
      width="81"
      height="81"
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check">
        <mask
          id="mask0_2668_33445"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="81"
          height="81"
        >
          <rect
            id="Bounding box"
            x="0.5"
            y="0.5"
            width="80"
            height="80"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_2668_33445)">
          <g id="Vector">
            <path
              d="M80.5 40.5C80.5 62.5914 62.5914 80.5 40.5 80.5C18.4086 80.5 0.5 62.5914 0.5 40.5C0.5 18.4086 18.4086 0.5 40.5 0.5C62.5914 0.5 80.5 18.4086 80.5 40.5Z"
              fill="#47D6FA"
              fillOpacity="0.16"
            />
            <path
              d="M67.1668 40.4999C67.1668 55.2275 55.2278 67.1665 40.5002 67.1665C25.7726 67.1665 13.8335 55.2275 13.8335 40.4999C13.8335 25.7723 25.7726 13.8332 40.5002 13.8332C55.2278 13.8332 67.1668 25.7723 67.1668 40.4999Z"
              fill="white"
            />
            <path
              d="M36.02 46.2599L29.14 39.3799C28.5533 38.7932 27.8067 38.4999 26.9 38.4999C25.9933 38.4999 25.2467 38.7932 24.66 39.3799C24.0733 39.9666 23.78 40.7132 23.78 41.6199C23.78 42.5266 24.0733 43.2732 24.66 43.8599L33.78 52.9799C34.42 53.6199 35.1667 53.9399 36.02 53.9399C36.8733 53.9399 37.62 53.6199 38.26 52.9799L56.34 34.8999C56.9267 34.3132 57.22 33.5666 57.22 32.6599C57.22 31.7532 56.9267 31.0065 56.34 30.4199C55.7533 29.8332 55.0067 29.5399 54.1 29.5399C53.1933 29.5399 52.4467 29.8332 51.86 30.4199L36.02 46.2599ZM40.5 72.5C36.0733 72.5 31.9133 71.66 28.02 69.9799C24.1267 68.2999 20.74 66.0199 17.86 63.1399C14.98 60.2599 12.7 56.8733 11.02 52.9799C9.34 49.0866 8.5 44.9266 8.5 40.4999C8.5 36.0732 9.34 31.9132 11.02 28.0199C12.7 24.1265 14.98 20.7399 17.86 17.8599C20.74 14.9798 24.1267 12.6998 28.02 11.0198C31.9133 9.33984 36.0733 8.49984 40.5 8.49984C44.9267 8.49984 49.0867 9.33984 52.98 11.0198C56.8733 12.6998 60.26 14.9798 63.14 17.8599C66.02 20.7399 68.3 24.1265 69.98 28.0199C71.66 31.9132 72.5 36.0732 72.5 40.4999C72.5 44.9266 71.66 49.0866 69.98 52.9799C68.3 56.8733 66.02 60.2599 63.14 63.1399C60.26 66.0199 56.8733 68.2999 52.98 69.9799C49.0867 71.66 44.9267 72.5 40.5 72.5Z"
              fill="#009EFA"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
